module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 60
// module chunks = 0